@if (!isPDF()) {
  <div>
    <compare-actions-toolbar
      [reportData]="reportData()"
      [currentView]="currentView()"
      [templates]="templateFieldsCatalog"
      [isUKFeaturesEnabled]="isUKFeaturesEnabled()"
      (templateChange)="onTemplateSelected($event)"
      >
    </compare-actions-toolbar>
  </div>
}
@if (headerGroups || bodyGroups) {
  <div class="condensed-list-wrapper">
    @for (reportItem of reportItems; track reportItem) {
      <section class="availability-section-container">
        <div class="availability-section">
          <!-- HEADER -->
          <ng-container>
            <div [ngClass]="{ 'is-highlighted': reportItem.isHighlighted }"></div>
            @if (headerGroups != null) {
              <rep-condensed-header
                [reportRecordData]="reportItem"
                [reportOptions]="reportOptions()"
                [headerGroups]="headerGroups"
                [currentView]="currentView()"
                [templateProjectionMap]="templateProjectionMap()"
                (reportUpdateClick)="reportUpdateClick.emit($event)"
              ></rep-condensed-header>
            } @else {
              {{ 'reports.condensedView' | translate }}
            }
          </ng-container>
          <ng-template #fullReportHeader>
            <!-- TODO(ppt): implement full header component when required -->
          </ng-template>
          <!-- BODY -->
          @for (record of reportItem.data; track record; let i = $index) {
            @if (bodyGroups) {
              <rep-condensed-body
                [isPDF]="isPDF()"
                [entity]="reportData().entity"
                [reportOptions]="reportOptions()"
                [reportRecordData]="reportItem | condensedRecordData: { recordIndex: i }"
                [bodyGroups]="bodyGroups"
                [footerGroups]="footerGroups"
                [currentView]="currentView()"
                [templateProjectionMap]="templateProjectionMap()"
                (removeRecord)="removeRecordFromReport(reportItem, i)"
                (reportUpdateClick)="reportUpdateClick.emit($event)"
              ></rep-condensed-body>
            } @else {
              {{ 'reports.condensedView' | translate }}
            }
          }
          <div class="divider"></div>
        </div>
      </section>
    }
  </div>
} @else {
  {{ 'reports.condensedView' | translate }}
}
